import Joblisting from "./Joblisting";
import Jobs from "./Jobs";
import NoPage from "./NoPage";
import useLocalStorageState from 'use-local-storage-state';
import { BrowserRouter, Routes, Route } from "react-router-dom";
const Controller = () => {  
    const [token, setToken] = useLocalStorageState('token', '');
    return (<BrowserRouter>
            <Routes>
            <Route index element={<Joblisting />} />
            <Route path="/jobs/:id" element={<Jobs />} />
            <Route path="*" element={<NoPage />} />
            </Routes>
            </BrowserRouter>
            
            );
}
export default Controller;